import { Button } from '@mui/material';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltips';
import { Typography } from '../Typography';
import NavLogo from './NavLogo';
import NavigationItem from './NavigationItem';
import { NavigationsBarProps } from './types';

const NavigationBar = (props: NavigationsBarProps) => {
  const {
    logo,
    navLists,
    className,
    onExpand,
    expanded,
    onClickLogo,
    isLogoSelected,
    bottomSection,
    ...restProps
  } = props;

  const finalClassName = [
    'hidden md:flex py-3 px-2 justify-between h-screen transition-all duration-300 flex-col bg-white border-r border-Other/Outlinedborder-stroke',
    expanded ? 'w-[216px] z-20' : 'w-[64px]',
    className,
  ].join(' ');

  return (
    <>
      <div>
        <nav
          {...restProps}
          className={finalClassName}
          style={{
            transition: 'all 300ms',
          }}
        >
          <div
            className={[
              'flex w-full flex-col justify-start gap-4 transition-all duration-300',
              expanded ? 'w-[200px]' : 'w-[48px]',
            ].join(' ')}
          >
            <Tooltip enterDelay={500} title={expanded ? undefined : 'Mở rộng'}>
              <div className="w-fit px-2">
                <Button
                  variant="medium_emphasis_v2"
                  className={[
                    'flex !h-8 !min-w-[unset] gap-1',
                    expanded ? 'w-fit px-[10px] py-2' : 'w-8',
                  ].join(' ')}
                  onClick={onExpand}
                >
                  <Icon
                    iconName={expanded ? 'chevron-left' : 'chevron-right'}
                    width={16}
                    height={16}
                  />
                  {expanded && (
                    <Typography variant="button3" className="whitespace-nowrap">
                      Thu nhỏ
                    </Typography>
                  )}
                </Button>
              </div>
            </Tooltip>
            <div
              className={[
                'transition-all duration-300',
                expanded ? 'w-[200px]' : 'w-[48px]',
              ].join(' ')}
            >
              <NavLogo expand={expanded} logo={logo} onClick={onClickLogo} />
              {navLists.map((item) => {
                const { startAdornment } = item;
                return (
                  <div key={item.id}>
                    {startAdornment}
                    <div className="flex flex-col gap-2 px-1 py-2">
                      {item.navItems.map((navItem) =>
                        navItem.renderChild ? (
                          navItem.renderChild()
                        ) : (
                          <NavigationItem
                            key={navItem.id}
                            navItem={navItem}
                            expand={expanded}
                          />
                        )
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {bottomSection}
        </nav>
      </div>

      {expanded && (
        <div
          className="fixed inset-0 z-[11] bg-[#00000080]"
          onClick={onExpand}
        />
      )}
    </>
  );
};

export default NavigationBar;
